import React, { FC, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Button, Form, Input, Skeleton } from 'antd';
import { useLoginMutation } from '../../../hooks/useLoginMutation';
import { useNavigate } from 'react-router-dom';
import { useFetchUser } from '../../../hooks/useFetchUser';
import { PrimaryButton } from '../../../components/PrimaryButton';

const LoginDiv: FC = () => {
  const navigate = useNavigate();
  const loginMutation = useLoginMutation();
  const user = useFetchUser();

  const goToPasswordReset = (ev: any) => {
    ev.preventDefault();
    window.location.href = 'https://accounts.starsacramento.org/reset/';
  };

  const handleLogin = (values: { username: string; password: string }) => {
    loginMutation.mutate(values);
  };

  useEffect(() => {
    if (user.data?.id) {
      navigate('/');
    }
  }, [user, navigate]);

  return (
    <>
      {(loginMutation.isLoading || user.isLoading) && (
        <Skeleton
          active
          loading={loginMutation.isLoading}
          paragraph={{ rows: 4 }}
        />
      )}
      {!loginMutation.isLoading && !user.isLoading && (
        <Card style={{ paddingBottom: 0 }} className={'mb-4'}>
          <Card.Body className={'pt-0'}>
            <div
              className={'text-center pt-4 pb-3 mb-3'}
              style={{ borderBottom: '1px solid rgba(0,0,0,0.1)' }}
            >
              <h1 style={{ fontSize: '18px' }}>
                Welcome to STAR Program Registration
              </h1>
            </div>

            <p
              style={{ fontSize: '11px', textAlign: 'center' }}
              className={'pb-3'}
            >
              <b>{`Already Have An Account?`}</b>
              <br />
              {`Go Ahead And Log In!`}
            </p>

            <Form
              name="basic"
              labelCol={{ span: 8 }}
              initialValues={{ remember: true }}
              onFinish={handleLogin}
              className="flex flex-col"
            >
              <Form.Item
                label="Email"
                name="username"
                rules={[
                  { required: true, message: 'Please input your email!' },
                ]}
              >
                <Input autoComplete="username" />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[
                  { required: true, message: 'Please input your password!' },
                ]}
              >
                <Input.Password autoComplete="current-password" />
              </Form.Item>

              <Form.Item className="w-full lg:w-[67%] self-end">
                <PrimaryButton
                  type="primary"
                  block
                  size="large"
                  htmlType="submit"
                  className="lg:ml-0 mr-32"
                >
                  Log In
                </PrimaryButton>
                <div className="pt-3">
                  <Button
                    onClick={goToPasswordReset}
                    type="link"
                    block
                    style={{ color: '#703895' }}
                  >
                    Forgot Your Password?
                  </Button>
                </div>
              </Form.Item>

              {loginMutation.isError && (
                <div className={'alert alert-danger'}>
                  <b>Error: </b>{' '}
                  {loginMutation.error?.response?.data?.message ||
                    'An error occurred'}
                </div>
              )}
            </Form>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default LoginDiv;
